import { render, staticRenderFns } from "./EDocuments.vue?vue&type=template&id=b9a57122&"
import script from "./EDocuments.vue?vue&type=script&lang=js&"
export * from "./EDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports